<!-- <div class="dhl-group-title-v2">
  Status Information
</div> -->
<div id="progress-indicator">
  <span *ngFor="let status of statuses;let i = index" >
    <span [ngClass]="{'circle-desc':true, 'hideInMobile' :index!==i, 'circle-desc-active':orderStatus == status}" [ngStyle] = "{'marginleft':i===0, 'marginreft':i=== count-1}" >
      {{ getStatus(status) }}
    </span>
     <!-- <span [ngClass]="{'time-desc':true,'hideInMobile' :index!=i}" style = "margin-left: 0px;">{{ dateArray[i] }}</span>  -->
    <div *ngIf="(responseStatus ==='complete' && status != 'Complete') || (responseStatus === 'in progress')"
      [ngClass]="{'circles':true, 'completed': (orderStatus === status || i<=index), 'ongoing': i===index+1}">
      <img [src]="img_paths[i]">
    </div>
    <div *ngIf="status === 'Complete' && responseStatus === 'complete'" [ngClass]="{'circles':true,
        'completed': ((orderStatus == status || i<=index) && successRecords === totalRecords),
        'ongoing': i===index+1,
        'incomplete': successRecords < totalRecords && successRecords > 0,
        'cancelled': successRecords == 0}">
      <img [src]="img_paths[i]">
    </div>
      <span [style.width.%] = "div-10" style ="display: inline-block; vertical-align: bottom;" *ngIf="(i !== statuses.length-1)">
      <div class="progress-bar" style = "width:100%;" >
        <div class="completed-bar" *ngIf="i === 0"></div>
        <div  class = "progress-bar2" [style.width.%]="percentage" *ngIf = "orderStatus === status"></div> <!-- {{successRecords}}/{{totalRecords}} have been successfully created-->
        <div *ngIf="responseStatus === 'complete' && i > 0">
          <div class="cancelled-bar" *ngIf = " successRecords == 0"></div>
          <div class="incomplete-bar" *ngIf = "successRecords > 0 && successRecords < totalRecords"></div>
          <div class="completed-bar" *ngIf = "totalRecords == successRecords"></div>
        </div>
      </div> 
    </span>
  </span>
  </div>
  <div class="status">{{successRecords}}/{{totalRecords}} orders created successfully</div>
  <app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
